<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-activity" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Activity Log</h4>
              <small style="opacity: .8;">Track staff actions and system events</small>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- Filter Card -->
        <div class="card table-card shadow mb-4">
          <div class="form-card-header">
            <div class="section-number"><i class="fe fe-filter" style="font-size:13px;"></i></div>
            <div>
              <p class="mb-0 text-white font-weight-bold" style="font-size:.95rem;">Filter Parameters</p>
              <small style="color:rgba(255,255,255,.7);">Narrow activity results by staff, type, model and date</small>
            </div>
          </div>
          <div class="card-body">
            <div class="row">

              <div class="form-group col-md-4">
                <label class="info-label d-block mb-1">Select Staff</label>
                <v-select v-model="filter_field.causer_id" :options="employees" :reduce="full_name => full_name.id"
                  label="full_name"></v-select>

                <!-- <select class="form-control" v-model="filter_field.causer_id">
                  <option :value="employee.id" v-for="employee in employees" :key="employee">
                    {{ employee.full_name }}
                  </option>
                </select> -->
              </div>

              <div class="form-group col-md-4">
                <label class="info-label d-block mb-1">Action Type</label>
                <select class="form-control" v-model="filter_field.description">
                  <option :value="desc" v-for="desc in descriptions" :key="desc">{{ desc }}</option>
                </select>
              </div>

              <div class="form-group col-md-4">
                <label class="info-label d-block mb-1">Model</label>
                <v-select multiple v-model="filter_field.causer_type" :reduce="name => name.model" label="name"
                  :options="causer_types" />
              </div>

              <div class="form-group col-md-4">
                <label class="info-label d-block mb-1"><i class="fe fe-calendar mr-1"></i>Start Date</label>
                <input type="date" class="form-control" v-model="filter_field.from" />
              </div>

              <div class="form-group col-md-4">
                <label class="info-label d-block mb-1"><i class="fe fe-calendar mr-1"></i>End Date</label>
                <input type="date" class="form-control" v-model="filter_field.to" />
              </div>

              <div class="form-group col-md-4">
                <label class="info-label d-block mb-1">Rows</label>
                <select class="form-control" v-model="filter_field.per_page">
                  <option value="30">30</option>
                  <option value="100">100</option>
                  <option value="500">500</option>
                  <option value="1000">1,000</option>
                  <option value="2000">2,000</option>
                  <option value="5000">5,000</option>
                  <option value="10000">10,000</option>
                  <option value="20000">20,000</option>
                  <option value="30000">30,000</option>
                  <option value="40000">40,000</option>
                  <option value="50000">50,000</option>
                  <option value="100000">100,000</option>
                  <option value="200000">200,000</option>
                  <option value="500000">500,000</option>
                </select>
              </div>

              <div class="col-md-12 pt-2 border-top">
                <div class="d-flex" style="gap: 8px;">
                  <button class="btn btn-submit px-4" @click="getActivities('json', 1)">
                    <i class="fe fe-filter mr-1"></i> Filter
                  </button>
                  <button class="btn btn-outline-success" @click="getActivities('excel')" :disabled="isExporting">
                    <span v-if="isExporting">
                      <i class="mdi mdi-loading mdi-spin mr-1"></i> Exporting, please wait…
                    </span>
                    <span v-else>
                      <i class="fe fe-download mr-1"></i> Export Excel
                    </span>
                  </button>
                  <button class="btn btn-outline-secondary">
                    <download-excel :data="activities.data" :fields="activity_export_fields" type="xls"
                      :escapeCsv="false" name="activities.xls">
                      <i class="fe fe-download mr-1"></i> Export Current Page
                    </download-excel>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- Table Card -->
        <div class="card table-card shadow mb-4">
          <div class="d-flex align-items-center justify-content-between px-4 pt-4 pb-3">
            <div class="d-flex align-items-center">
              <i class="fe fe-list text-primary mr-2"></i>
              <h6 class="mb-0 font-weight-bold">Activity Records</h6>
            </div>
            <span class="badge badge-soft-primary" style="font-size:.85rem;">{{ activities.total }} total</span>
          </div>
          <div class="table-responsive">
            <table class="table align-td-middle mb-0">
              <thead class="table-head">
                <tr>
                  <th class="table-th">Staff</th>
                  <th class="table-th">On</th>
                  <th class="table-th">Timestamp</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-row" v-for="activity in activities.data" v-bind:key="activity.id">
                  <td>
                    <p class="mb-0 font-weight-bold" style="font-size:.88rem;">{{ activity.causer.full_name }}</p>
                    <span class="badge badge-soft-danger" style="font-size:.72rem;">{{ activity.description }}</span>
                  </td>
                  <td>
                    <div class="d-flex flex-wrap" style="gap:3px;">
                      <!-- <span class="badge badge-soft-dark" style="font-size:.72rem;"
                        v-for="(value, key) in activity.properties.attributes" v-bind:key="key">
                        {{ value }}
                      </span> -->
                      {{ activity.subject_type ? activity.subject_type.split('\\').pop() : '' }}
                    </div>
                  </td>
                  <td style="font-size:.82rem; color:#64748b;">
                    {{ activity.created_at | moment("dddd, MMMM Do YYYY, h:mm:ss a") }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-body pt-2">
            <div class="d-flex align-items-center justify-content-between flex-wrap" style="gap:8px;">
              <small class="text-muted" v-if="activities.total">
                Showing {{ activities.from }} to {{ activities.to }} of {{ activities.total }}
              </small>
              <b-pagination class="mb-0 ml-auto" v-model="currentPage" :total-rows="rows"
                :per-page="filter_field.per_page" @input="getActivities('json', currentPage)"></b-pagination>
            </div>
          </div>
        </div>

      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  // Init plugin
  import moment from "moment";

  moment().format();

  import SectorsJson from "@/json/sectors.json";
  let agency = JSON.parse(localStorage.getItem("agency"));

  export default {
    components: {
      Navbar,
      Loading,
    },
    data() {
      return {
        paginate_value: 0,
        employees: "",
        causer_types: [
          { name: "Enrollees", model: "App\\Models\\User" },
          { name: "Dependents", model: "App\\Dependants" },
          { name: "Encounters", model: "App\\Service_summary" },
          { name: "Claim", model: "App\\Claims" },
          { name: "Payment", model: "App\\Transactions" },
        ],
        descriptions: [
          "created",
          "updated",
          "deleted",
          "restored",
          "User signed in",
          "User signed out",
        ],
        user: null,
        isLoading: false,
        isExporting: false,
        fullPage: true,
        encounterform: false,
        filterparams: false,
        diseases: "",
        providers: "",

        string_data: "",
        lga_states: "",
        sectors: SectorsJson,
        activities: {
          data: [],
        },
        activity_export_fields: {
          "Staff": "causer.full_name",
          "Subject Name": "subject.full_name",
          "NIN": "subject.nimc_number",
          "Gender": "subject.gender",
          "Sector": "subject.sector",
          "Place of Work": "subject.place_of_work",
          "LGA": "subject.localgovt.local_name",
          "Ward": "subject.ward.ward_name",
          "Address": "subject.address1",
          "Phone Number": "subject.phone_number",
          "Facility": "subject.userprovider.agency_name",
          "Subject Type": "subject_type",
          "Insurance ID": "subject.id_card_number",
          "Action": "description",
          "Date": "created_at",
          "Date Enrolled": "subject.created_at",
        },
        filter_field: {
          format: "json",
          per_page: 30,
          causer_type: [
            "App\\Models\\User",
            "App\\Models\\Dependents"],
          causer_id: "",
          description: "",
          provider_id: "",
          enrollee: "",
          localgovt: "",
          selected_agency: "",
          sector: "",
          date: "",
          from: moment().subtract(30, "days").format("YYYY-MM-DD"),
          to: moment().format("YYYY-MM-DD"),
          is_confirmed: "",
        },
        currentPage: 1,
        rows: 0,
      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
    },
    methods: {
      getActivities(format, page) {
        this.user = JSON.parse(localStorage.getItem("user"));
        if (format === "excel") this.isExporting = true;
        this.isLoading = true;
        const requestFormat = format || "json";
        this.axios
          .post(
            `/api/v1/auth/agency-activities`,
            {
              from: this.filter_field.from,
              to: this.filter_field.to,
              per_page: this.filter_field.per_page,
              page: page ? page : this.currentPage,
              causer_type: this.filter_field.causer_type,
              causer_id: this.filter_field.causer_id,
              description: this.filter_field.description,
              agency_id: agency.id,
              format: requestFormat,
            },
            requestFormat === "excel"
              ? {
                responseType: "blob",
                timeout: 0,
              }
              : {}
          )
          .then((response) => {

            if (requestFormat === "excel") {
              // If the server sends JSON instead of the file (an error, or a server that
              // doesn't support format=excel yet), show its message instead of saving a broken .xlsx.
              const contentType = String((response.headers && response.headers["content-type"]) || "");
              if (contentType.includes("json")) {
                this.isLoading = false;
                this.isExporting = false;
                response.data.text().then((text) => {
                  let message = "Export failed: the server did not return an Excel file.";
                  try {
                    const body = JSON.parse(text);
                    if (body && body.current_page !== undefined) {
                      message = "Export failed: the server is running an older version that cannot export Excel yet.";
                    } else if (body && body.message) {
                      message = "Export failed: " + body.message;
                    }
                  } catch (e) { /* not JSON */ }
                  console.error("Activities export response:", text.slice(0, 500));
                  this.$toasted.error(message, { position: "top-center", duration: 6000 });
                });
                return;
              }

              const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute(
                "download",
                `activities_${new Date().toISOString().slice(0, 10)}.xlsx`
              );
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);

              this.$toasted.success("Excel file downloaded successfully", {
                position: "top-center",
                duration: 3000,
              });

              this.isLoading = false;
              this.isExporting = false;
              return;
            }

            this.$toasted.success("Filtered Successfully", {
              position: "top-center",
              duration: 3000,
            });

            this.activities = response.data;
            this.rows = response.data.total;
            this.currentPage = response.data.current_page;
            this.isLoading = false;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
            this.isExporting = false;
            this.$toasted.error(requestFormat === "excel" ? "Export failed, please try again" : "Unable to load activities", {
              position: "top-center",
              duration: 3000,
            });
          });
      },
      getEmployees() {
        this.axios
          .get(`/api/v1/auth/getEmployee/${agency.id}`)
          .then((response) => {
            this.employees = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
    },
    created() {
      this.getActivities();
      this.getEmployees();
    },
  };
</script>